// extracted by mini-css-extract-plugin
export default {"container":"eX-z","title":"fX-z","link":"gX-z"};